/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Interview_Qbank_Label_RoleInputs */

const en_interview_qbank_label_role = /** @type {(inputs: Interview_Qbank_Label_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Role Type`)
};

const de_interview_qbank_label_role = /** @type {(inputs: Interview_Qbank_Label_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rollentyp`)
};

const fr_interview_qbank_label_role = /** @type {(inputs: Interview_Qbank_Label_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type de poste`)
};

const es_interview_qbank_label_role = /** @type {(inputs: Interview_Qbank_Label_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de puesto`)
};

const it_interview_qbank_label_role = /** @type {(inputs: Interview_Qbank_Label_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo di ruolo`)
};

const nl_interview_qbank_label_role = /** @type {(inputs: Interview_Qbank_Label_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type rol`)
};

const pl_interview_qbank_label_role = /** @type {(inputs: Interview_Qbank_Label_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typ roli`)
};

const fi_interview_qbank_label_role = /** @type {(inputs: Interview_Qbank_Label_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tehtävätyyppi`)
};

const da_interview_qbank_label_role = /** @type {(inputs: Interview_Qbank_Label_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rolletype`)
};

const sv_interview_qbank_label_role = /** @type {(inputs: Interview_Qbank_Label_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rolltyp`)
};

/**
* | output |
* | --- |
* | "Role Type" |
*
* @param {Interview_Qbank_Label_RoleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const interview_qbank_label_role = /** @type {((inputs?: Interview_Qbank_Label_RoleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Interview_Qbank_Label_RoleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_interview_qbank_label_role(inputs)
	if (locale === "fr") return fr_interview_qbank_label_role(inputs)
	if (locale === "es") return es_interview_qbank_label_role(inputs)
	if (locale === "it") return it_interview_qbank_label_role(inputs)
	if (locale === "nl") return nl_interview_qbank_label_role(inputs)
	if (locale === "pl") return pl_interview_qbank_label_role(inputs)
	if (locale === "fi") return fi_interview_qbank_label_role(inputs)
	if (locale === "da") return da_interview_qbank_label_role(inputs)
	if (locale === "sv") return sv_interview_qbank_label_role(inputs)
	return en_interview_qbank_label_role(inputs)
});